import { Label } from '../label';

export abstract class SystemLabel extends Label {
  abstract getSortOrderTitle(): string;
}
